import { motion } from "framer-motion";
import { Flame, Clock, AlertTriangle, TrendingUp } from "lucide-react";

const StockUrgency = ({ stock, editionSize = null, soldCount = 0 }) => {
  // Don't show if plenty of stock
  if (stock > 10 && !editionSize) return null;

  // Calculate urgency level
  let urgencyLevel = "normal";
  let message = "";
  let Icon = TrendingUp;
  let colorClass = "text-muted-foreground";
  let bgClass = "bg-muted/50";

  if (stock === 0) {
    urgencyLevel = "sold_out";
    message = "Sold Out";
    Icon = AlertTriangle;
    colorClass = "text-red-500";
    bgClass = "bg-red-50";
  } else if (stock <= 2) {
    urgencyLevel = "critical";
    message = `Only ${stock} left!`;
    Icon = Flame;
    colorClass = "text-red-500";
    bgClass = "bg-red-50";
  } else if (stock <= 5) {
    urgencyLevel = "low";
    message = `Only ${stock} remaining`;
    Icon = Clock;
    colorClass = "text-amber-600";
    bgClass = "bg-amber-50";
  } else if (editionSize && soldCount > 0) {
    const percentSold = (soldCount / editionSize) * 100;
    if (percentSold >= 80) {
      urgencyLevel = "high_demand";
      message = `${Math.round(percentSold)}% sold`;
      Icon = TrendingUp;
      colorClass = "text-primary";
      bgClass = "bg-primary/10";
    } else if (percentSold >= 50) {
      urgencyLevel = "selling";
      message = `Over half sold`;
      Icon = TrendingUp;
      colorClass = "text-amber-600";
      bgClass = "bg-amber-50";
    }
  }

  if (!message) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${bgClass}`}
      data-testid="stock-urgency"
    >
      <Icon className={`h-4 w-4 ${colorClass} ${urgencyLevel === 'critical' ? 'animate-pulse' : ''}`} />
      <span className={`text-sm font-medium ${colorClass}`}>
        {message}
      </span>
    </motion.div>
  );
};

// Social proof indicator
export const SocialProof = ({ viewCount, purchaseCount }) => {
  if (!viewCount && !purchaseCount) return null;

  return (
    <div className="flex items-center gap-4 text-sm text-muted-foreground">
      {viewCount > 10 && (
        <span className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
          {viewCount} people viewing
        </span>
      )}
      {purchaseCount > 0 && (
        <span>
          {purchaseCount} sold recently
        </span>
      )}
    </div>
  );
};

export default StockUrgency;
